<script>
    export default {
        name: 'modal',
        props: ['showModal'],

        methods: {
            close() {
                this.$emit('close');
            },
        },
    };
</script>
<template>
    <div v-if="showModal">
        <div class="modal-backdrop">
        </div>

        <div class="modal-container">
            <div class="modal" role="dialog">
                <slot></slot>

                <div class="grid-container full modal-footer">
                    <div class="grid-x grid-margin-x grid-margin-y">
                        <div class="cell">
                            <slot name="buttons"></slot>
                            <button @click="$emit('close')" class="btn">Sluiten</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .modal-backdrop,
    .modal-container {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 91020;
    }

    .modal-backdrop {
        background-color: rgba(0, 0, 0, 0.3);
    }

    .modal {
        background: #FFFFFF;
        overflow-x: auto;
        display: flex;
        flex-direction: column;
        width: 80vw;
        height: 80vh;
        padding: 0.8rem;
    }

    .modal-footer .btn {
        margin: 1rem;
    }
</style>
